import React from 'react';

const Header = () => {
  return (
    <>
      <div className="navbar-bg"></div>
      <nav className="navbar navbar-expand-lg main-navbar sticky">
        <div className="form-inline mr-auto">
          <ul className="navbar-nav mr-3">
            <li><a href="#" data-toggle="sidebar" className="nav-link nav-link-lg font-bold collapse-btn"><i className="fas fa-align-justify font-bold"></i>
            </a></li>
            <li><a href="#" className="nav-link nav-link-lg font-bold fullscreen-btn"><i className="fa fa-expand"></i></a></li>
          </ul>
        </div>
        <ul className="navbar-nav navbar-right">
          <li className="dropdown">
            <a href="#" data-toggle="dropdown" className="nav-link dropdown-toggle nav-link-lg nav-link-user">
              <span
                className="user-img-radious-style d-inline-flex align-items-center justify-content-center text-white"
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: '#6777ef',
                  fontWeight: '700',
                  fontSize: '15px',
                  lineHeight: 1,
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
                  userSelect: 'none',
                  verticalAlign: 'middle',
                }}
              >
                A
              </span>
              <span className="d-sm-none d-lg-inline-block !text-black" style={{ color: 'black', marginLeft: 10 }}>Admin User</span>
            </a>
            <div className="dropdown-menu dropdown-menu-right pullDown">
              <div className="dropdown-title">Admin User</div>
              <a href="/profile" className="dropdown-item has-icon"><i className="fa-solid fa-user"></i> Profile</a>
              <div className="dropdown-divider"></div>
              <a href="/Login" className="dropdown-item has-icon text-danger"><i className="fas fa-sign-out-alt"></i> Logout</a>
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Header;
